export const Abs = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  zIndex: 10,
  transform: 'translateX(-50%) translateY(-50%)',
}


// WEBPACK FOOTER //
// ./src/styles/layout.js